const styles = (theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(14),
  },
});

export default styles;
